import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'litmus-label',
    templateUrl: './litmus-label.component.html',
    styleUrls: ['./litmus-label.component.scss'],
    standalone: false
})
export class LitmusLabelComponent implements OnChanges{
  @Input() data:any=[]
  labels:any = [];
  ngOnChanges(changes: SimpleChanges): void {
    if(this.data){
      this.labels = (typeof this.data == 'string')?JSON.parse(this.data):this.data;
    }
  }
}
